import { ActionButton } from "@/dev/ui/verify-footer";
import { useNavigate } from "react-router";

const CancelError = () => {
  const navigate = useNavigate();
  const handleGoHome = () => {
    navigate("/");
  };
  return (
    <div className=" p-4">
      <div className="  p-8  w-full text-center" dir="rtl">
        {/* Error Icon */}
        <div className="mb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-red-500 mb-2">שגיאה בטעינת הנתונים</h2>
          <div className="w-12 h-1 bg-red-400 mx-auto rounded-full"></div>
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <p className="text-red-800 leading-relaxed">לקוח לא נמצא במערכת או שכבר בוטל המינוי שלו לשירות המיילים</p>
          </div>

          {/* Additional Info */}
          <div className="text-gray-600 text-sm space-y-2">
            <p>ייתכן שאחת מהסיבות הבאות:</p>
            <ul className="text-right space-y-1">
              <li className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0"></div>
                <span>כתובת המייל לא רשומה במערכת</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0"></div>
                <span>המינוי כבר בוטל בעבר</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0"></div>
                <span>שגיאה זמנית במערכת</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Action Button */}
        <div className="space-y-4 flex items-center justify-center w-full">
          <ActionButton onClick={handleGoHome}>
            <span className="text-lg">עבור לדף הבית</span>
          </ActionButton>

          {/* Alternative Actions */}
        </div>

        {/* Footer Help */}
        <div className="mt-8 pt-6 border-t border-gray-100">
          <p className="text-xs text-gray-500">
            זקוק לעזרה? צור קשר עמנו בכתובת{" "}
            <a href="mailto:info@zoooz.co" className="text-blue-600 hover:text-blue-800">
              info@zoooz.co
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
export default CancelError;
